import { render, staticRenderFns } from "./modify-config.vue?vue&type=template&id=3014e331&scoped=true"
import script from "./modify-config.vue?vue&type=script&lang=ts"
export * from "./modify-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3014e331",
  null
  
)

export default component.exports